<template>
  <v-card>
    <v-card-title class="primary">
      <span class="tertiary--text headline">{{ $t('scalingImportResults') }}</span>
      <v-spacer/>
      <Icon
        icon="mdi-close"
        iconColor="tertiary"
        :small="false"
        @icon-clicked="$emit('close')"
      />
    </v-card-title>
    <v-card-text class="mt-4">
      <v-list dense>
        <v-list-item v-for="(result, index) in results" :key="index">
          <v-list-item-icon>
            <v-icon :color="statusColor(result.status)">{{ statusIcon(result.status) }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">{{ result.tab }}</v-list-item-title>
            <v-list-item-subtitle style="white-space: normal; word-break: break-word;">
              {{ result.message }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { ImportTabStatus } from '@/utils/Enumerations'

export default {
  name: 'ScalingImportResultsDialog',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    results: {
      type: Array,
      required: true
    }
  },

  methods: {
    statusIcon (status) {
      switch (status) {
        case ImportTabStatus.Success.value: return 'mdi-check-circle'
        case ImportTabStatus.Skipped.value: return 'mdi-alert'
        case ImportTabStatus.SkippedPrerequisite.value: return 'mdi-alert'
        case ImportTabStatus.Failed.value: return 'mdi-close-circle'
        default: return 'mdi-help-circle'
      }
    },

    statusColor (status) {
      switch (status) {
        case ImportTabStatus.Success.value: return 'success'
        case ImportTabStatus.Skipped.value: return 'warning'
        case ImportTabStatus.SkippedPrerequisite.value: return 'warning'
        case ImportTabStatus.Failed.value: return 'error'
        default: return 'grey'
      }
    }
  }
}
</script>
